import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { CompatibleBrowserGuard } from './compatible-browser.guard';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './shared/auth/auth.guard';
import { PortalComponent } from './shell/portal/portal.component';
import { LoginCallbackComponent } from './shell/login-callback/login-callback.component';
import { SessionTimeoutComponent } from "./shell/session-timeout/session-timeout.component";

const routes: Routes = [
  {
    path: "login/success",
    component: LoginComponent
  },
  {
    path: "login/callback",
    component: LoginCallbackComponent
  },
  {
    path: "session-timeout",
    component: SessionTimeoutComponent
  },
  {
    path: '',
    component: PortalComponent,
    loadChildren: () => import('./shell/portal.module').then(m => m.PortalModule),
    canActivate: [AuthGuard],
    canLoad: [CompatibleBrowserGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
